"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var IconSmartPhone = function IconSmartPhone(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-smart-phone",
    height: props.height,
    viewBox: "0 0 10 16",
    width: props.width,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: props.fill || "#141e37",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M7.012 14.489h-4.04c-.82 0-1.472-.626-1.472-1.383V2.883c0-.757.652-1.383 1.472-1.383l.558.65a1 1 0 0 0 .759.35h1.423a1 1 0 0 0 .77-.361l.53-.639c.82 0 1.472.626 1.472 1.383v8.672a.75.75 0 0 0 1.5 0V2.883C9.984 1.283 8.647 0 7.012 0h-4.04C1.337 0 0 1.284 0 2.883v10.223c0 1.599 1.337 2.883 2.972 2.883h4.04a.75.75 0 0 0 .75-.75c0-.414-.333-.695-.75-.75z",
    fillRule: "nonzero"
  }), _react["default"].createElement("circle", {
    cx: "9",
    cy: "14",
    r: "1"
  })));
};

var _default = IconSmartPhone;
exports["default"] = _default;